const algorithmFormPageTranslations = {
  0: {
    preMessage:
      "مرحبًا، سأطرح عليك بعض الأسئلة التي ستساعدنا في تصميم برنامج مخصص بالكامل لك.",
    message:
      "في البداية، نحتاج إلى معرفة بعض المعلومات الأساسية مثل: العمر، الوزن، الطول، ونسبة دهون الجسم.",
    intro: "يرجى ملء التفاصيل أدناه.",
    age: "العمر",
    weight: "الوزن",
    height: "الطول",
    bodyFat: "نسبة دهون الجسم",
    seeReferenceImage: "عرض المرجع البصري",
    bodyFatHelpButton: "ساعدني في تقدير نسبة الدهون",
    waist: "الخصر (سم)",
    neck: "الرقبة (سم)",
    hip: "الورك (سم) — للإناث فقط",
    calculateBF: "احسب نسبة الدهون",
    hint: "أدخل القياسات حتى يتم حساب نسبة الدهون بدقة.",
    measurements_required: "يرجى إدخال القياسات المطلوبة أولاً.",
  },
  1: {
    preMessage: "حان الوقت لمعرفة المزيد عنك.",
    message: "يرجى رفع تقرير In-Body الخاص بك، وأيضًا صور جسمك إن أمكن.",
  },
  2: {
    preMessage: "",
    message: "الآن، لنحدد هدفك الغذائي بدقة، لأنه يؤثر مباشرة على البرنامج 🎯",
    intro: "اختر هدفك بعناية لضمان أفضل نتائج ممكنة ✌️.",
    nutritionGoal: "الهدف الغذائي",

    // أهداف خسارة الوزن
    slimDownMild: "تنحيف بسيط",
    weightLossStandard: "خسارة وزن معتدلة",
    rapidFatLoss: "خسارة دهون سريعة (مكثفة)",

    // أهداف التوازن
    maintainBalance: "المحافظة على الوزن والتوازن",
    bodyRecomposition: "إعادة تشكيل الجسم",
    performanceSupport: "دعم الأداء البدني",

    // أهداف زيادة الوزن
    leanGainMild: "زيادة وزن بسيطة",
    muscleGainStandard: "زيادة عضلية معتدلة",
    bulkUpExtreme: "زيادة وزن قوية جدًا",
  },

  3: {
    preMessage: "",
    message: "اخبرنا اكثر عن المكونات الغذائية التي لا تحبها.",
  },
  4: {
    preMessage: "",
    message: "يرجى اختيار مستوى نشاطك اليومي المناسب.",
    activityLevel: "مستوى النشاط",
    sedentary: "خامل (نشاط بدني قليل أو معدوم)",
    lightlyActive: "خفيف (تمارين 1-3 أيام في الأسبوع)",
    moderatelyActive: "متوسط (تمارين 3-5 أيام في الأسبوع)",
    veryActive: "نشط (تمارين 6-7 أيام في الأسبوع)",
    extraActive: "رياضي (تمارين مكثفة مرتين يوميًا)",
  },
  5: {
    preMessage: "",
    message: "الآن، أخبرني عن عدد الوجبات التي تفضل تناولها يوميًا.",
    intro: "يرجى ملء التفاصيل أدناه.",
  },
  6: {
    preMessage:
      "رائع 😍، انتهينا من أسئلة التغذية. لننتقل الآن إلى أسئلة التمارين الرياضية.",
    message: "كم عدد الأيام التي تتمرن فيها أسبوعيًا؟",
  },
  7: {
    preMessage: "",
    message: "ما هو مستوى خبرتك في التمارين؟ يرجى الإجابة بصدق.",
    experienceLevel: "مستوى الخبرة",
    beginner: "مبتدئ",
    intermediate: "متوسط",
    advanced: "متقدم",
  },
  8: {
    preMessage:
      "في حال كان لديك أي مشكلات طبية، يرجى تزويدنا بجميع التشخيصات الطبية أو تشخيصات الإصابات إن وجدت.",
    message: "يرجى رفع التقارير الطبية أو تقارير الإصابات إن وجدت.",
  },
};

export default algorithmFormPageTranslations;
